import { connectorRoutingPolicyRegistry } from './routingPolicyRegistry';
import type { ConnectorRoutingPolicy } from './types';

export const resolveConnectorRoutingPolicy = (
  policyId: string | undefined,
  fallbackPolicyId = 'generic-bezier',
): ConnectorRoutingPolicy => {
  const policy =
    connectorRoutingPolicyRegistry.resolve(policyId) ??
    connectorRoutingPolicyRegistry.resolve(fallbackPolicyId) ??
    connectorRoutingPolicyRegistry.list()[0];

  if (!policy) {
    throw new Error('No connector routing policies are registered');
  }

  return policy;
};
